export default __webpack_public_path__ + "static/media/twitter.f61e1463.svg";